import {Component, Input, OnInit} from '@angular/core';

@Component ({
  selector: 'stick-block-ui',
  templateUrl: 'stick.template.html',
  styleUrls: ['stick.style.scss']
})
export class StickBlockUIComponent implements OnInit{
  @Input()
  public ItemStick: string;
  @Input()
  public BgStick: string;

  visibleStyle: any = {
    info: false,
    alarm: false,
    success: false,
    warn: false
  };
  ngOnInit () {
    for (let key in this.visibleStyle) {
      if (key === this.BgStick) {
        this.visibleStyle[key] = true;
      } else this.visibleStyle[key] = false;
    }
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/components/stiks/stick.component.ts